import { render, staticRenderFns } from "./PrazoReincidencia.vue?vue&type=template&id=4320d7fa&scoped=true&lang=pug&"
import script from "./PrazoReincidencia.vue?vue&type=script&lang=js&"
export * from "./PrazoReincidencia.vue?vue&type=script&lang=js&"
import style0 from "./PrazoReincidencia.vue?vue&type=style&index=0&id=4320d7fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320d7fa",
  null
  
)

export default component.exports